// Event Type - HUMAN defined enum
export var DetectorEvents = {
    Undefined: '0',
    AccountLogin: '1',
    AccountCreation: '2',
    PasswordReset: '3',
    PasswordUpdate: '4',
    ProfileUpdate: '5',
    ReputationClick: '6',
    Spin: '7',
    Payment: '8',
    GenericFormFill: '9',
    GenericButtonClick: '10',
};
